module.exports = __webpack_public_path__ + "static/media/pause-icon-blue.c00e97bd.svg";